export default ({
    config() {
        let host = '';
        let domin = '';
        let auth = '';
        let wx = '';
        let newAuth = ''
        //本地
        if (window.location.host.includes('localhost:8081')
            || window.location.host.includes('localhost:8080')
            || window.location.host.includes('.turboradio.cn')){
            host = 'https://distribution-new-backend.turboradio.cn/';
            domin = '.turboradio.cn';
            auth = 'https://jwt-frontend.turboradio.cn';
            wx = 'https://wx.turboradio.cn';
            newAuth = 'http://auth-backend.turboradio.cn';
        }
        //预发布
        if (window.location.host.includes('.uniondrug.net'))  {
            host = 'https://distribution-new-backend.uniondrug.net/';
            domin = '.uniondrug.net';
            auth = 'https://jwt-frontend.uniondrug.net';
            wx = 'https://wx.uniondrug.net';
            newAuth = 'https://auth-backend.uniondrug.net';
        }
        //生产
        if (window.location.host.includes('.uniondrug.cn')){
            host = 'https://distribution-new-backend.uniondrug.cn/';
            domin = '.uniondrug.cn';
            auth = 'https://jwt-frontend.uniondrug.cn';
            wx = 'https://wx.uniondrug.cn';
            newAuth = 'https://auth-backend.uniondrug.cn';
        }

        return {
            host,
            domin,
            auth,
            wx,
            newAuth
        };
    },
});

